"use client";

import { useAuthDialogContext } from "./AuthDialogContext";

export function useAuthDialog() {
  const { openAuthDialog, closeAuthDialog } = useAuthDialogContext();
  return { openAuthDialog, closeAuthDialog };
}
